import React from "react";
import { Navbar, Nav, Container, Button } from "react-bootstrap";
import { useNavigate, useLocation } from "react-router-dom";

const NavbarAdmin = ({ currentUser }) => {
  const navigate = useNavigate();
  const location = useLocation();

  const handleLogout = () => {
    sessionStorage.removeItem("currentUser"); 
    navigate("/login");
  };

  // Dynamic title based on route
  let title = "Admin Dashboard";
  if (location.pathname.startsWith("/admin/users/") && location.pathname !== "/admin/users") {
    title = "User Settings";
  }

  return (
    <Navbar bg="dark" variant="dark" expand="lg">
      <Container>
        <Navbar.Brand style={{ cursor: "pointer" }} onClick={() => navigate("/admin/users")}>
          {title}
        </Navbar.Brand>

        <Nav className="ms-auto align-items-center">
          {currentUser && (
            <span className="text-light me-3">
              Welcome, {currentUser.username}
            </span>
          )}
          <Button variant="outline-light" className="me-2" onClick={() => navigate("/admin/users")}>
            Home
          </Button>
          <Button variant="outline-light" onClick={handleLogout}>
            Logout
          </Button>
        </Nav>
      </Container>
    </Navbar>
  );
};

export default NavbarAdmin;
